export function clearStorage() {
    var preferedLanguage = localStorage.getItem("preferedLanguage")
    localStorage.clear();
    if (preferedLanguage) {
        localStorage.setItem("preferedLanguage", preferedLanguage);
    }
}
